import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Tooltip(theme: Theme) {
  const isLight = theme.palette.mode === 'light';

  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.grey[isLight ? 600 : 800],
          fontSize: '0.875rem',
          fontWeight: 400,
        },
        arrow: {
          color: theme.palette.grey[isLight ? 600 : 800],
        },
      },
    },
  };
}
